// extracted by mini-css-extract-plugin
module.exports = {"rotation":"SoluzioniSection_rotation__GLfra"};